import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=211bac26&scoped=true&"
import script from "./PedidosTable.vue?vue&type=script&lang=js&"
export * from "./PedidosTable.vue?vue&type=script&lang=js&"
import style0 from "./PedidosTable.vue?vue&type=style&index=0&id=211bac26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211bac26",
  null
  
)

export default component.exports